import React, { Component } from 'react';
import { Fstyr } from './Fstyr.js';

type Props = {
    show: boolean
    buttonAcceptLabel: string;
    buttonDeclineLabel: string;
    onAccept: () => void;
    onDecline: () => void;
    label: string;
    buttonGroupLabel?: string;
    layout?: any;
};

type State = {
    showSpinner: boolean
};

export class FstyrModal extends Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showSpinner: false
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.show && !this.props.show) this.setState({ showSpinner: false })
    }

    renderSegments() {
        if (this.props.layout)
            return (
                this.props.layout.map((segment: any) =>
                    <Fstyr.Segment
                        title={segment.label}
                    >
                        {this.renderInputs(segment.inputs)}
                    </Fstyr.Segment>
                )
            )
    }

    renderInputs(inputs: any) {
        return (
            inputs.map((input: any) =>
                <Fstyr.Input
                    label={input.label}
                    readonly={true}
                    value={input.value}
                    direction="row"
                />
            )
        )
    }

    render() {
        return (
            this.props.show &&
            <div className="fstyr-modal-background">
                <div className="fstyr-modal-container">
                    <Fstyr.Segment
                        title={this.props.label}
                        isPageTitle={true}
                    />
                    {this.renderSegments()}
                    <Fstyr.Segment
                        title={this.props.buttonGroupLabel}
                        isPageTitle={true}
                    >
                        <div className="fstyr-left-button-group">
                                <Fstyr.Button
                                    label={this.props.buttonAcceptLabel}
                                    type={"primary"}
                                    onClick={() => {
                                        this.setState({ showSpinner: true })
                                        this.props.onAccept()
                                    }}
                                    disabled={this.state.showSpinner}
                                />
                                <Fstyr.Button
                                    label={this.props.buttonDeclineLabel}
                                    type={"secondary"}
                                    onClick={() => { this.props.onDecline() }}
                                />
                            <Fstyr.Spinner
                                show={this.state.showSpinner}
                            />
                        </div>
                    </Fstyr.Segment>
                </div>
            </div>
        );
    }

}
